console.log('process.env', process.env)
const serverList = [
    {
        BASEURL: 'http://192.168.68.100:8404',
    },
    {
        BASEURL: 'https://www.huiwanyx.com/gameapi',
    },
];
let serverArr;

serverArr = serverList[1]
export default serverArr
